import { ExportStatus } from './common.js';

export const Kind = 'EXPORT_VERIFY_REGISTRATION' as const;
export { ExportStatus as Status };
